import isMobileLayout from '../utils/isMobileLayout';
import { useEffect, useState } from 'react';
import { applyCentinelaLightTheme } from './CentinelaPanelTheme';
import './CentinelaPanelTheme.css';

function CentinelaVehicleVisual({
  activo,
  puertasAbiertas,
  movimientoActivo,
  energiaInterrumpida,
  ignicionActiva,
  jammerActivo
}) {
  let visualTheme = {
    accent: '#64748b',
    glow: 'rgba(100,116,139,0.30)',
    state: 'inactive'
  };

  if (activo) {
    visualTheme = {
      accent: '#38bdf8',
      glow: 'rgba(14,165,233,0.48)',
      state: 'active'
    };
  }

  if (activo && ignicionActiva) {
    visualTheme = {
      accent: '#f59e0b',
      glow: 'rgba(245,158,11,0.52)',
      state: 'alert'
    };
  }

  if (activo && movimientoActivo) {
    visualTheme = {
      accent: '#22d3ee',
      glow: 'rgba(34,211,238,0.55)',
      state: 'movement'
    };
  }

  if (activo && puertasAbiertas) {
    visualTheme = {
      accent: '#ef4444',
      glow: 'rgba(239,68,68,0.58)',
      state: 'alert'
    };
  }

  if (activo && energiaInterrumpida) {
    visualTheme = {
      accent: '#ef4444',
      glow: 'rgba(239,68,68,0.62)',
      state: 'critical'
    };
  }

  if (activo && jammerActivo) {
    visualTheme = {
      accent: '#dc2626',
      glow: 'rgba(220,38,38,0.66)',
      state: 'critical'
    };
  }

  const visualKey = [
    activo,
    puertasAbiertas,
    movimientoActivo,
    energiaInterrumpida,
    ignicionActiva,
    jammerActivo
  ].join('-');

  return (
    <div
      key={visualKey}
      className={`centinela-core-stage ${
        activo
          ? 'centinela-core-stage-active'
          : 'centinela-core-stage-inactive'
      } ${
        visualTheme.state === 'critical' ||
        visualTheme.state === 'alert'
          ? 'centinela-core-stage-alert'
          : ''
      }`}
      style={{
        '--centinela-accent':
          visualTheme.accent,

        '--centinela-glow':
          visualTheme.glow
      }}
    >
      <style>
        {`
          @keyframes centinelaCoreEntrance {
            0% {
              opacity: 0;
              transform:
                perspective(800px)
                rotateX(24deg)
                rotateY(-26deg)
                scale(0.72);
            }

            60% {
              opacity: 1;
              transform:
                perspective(800px)
                rotateX(-4deg)
                rotateY(7deg)
                scale(1.06);
            }

            100% {
              opacity: 1;
              transform:
                perspective(800px)
                rotateX(0deg)
                rotateY(0deg)
                scale(1);
            }
          }

          @keyframes centinelaOuterRotation {
            from {
              transform: rotate(0deg);
            }

            to {
              transform: rotate(360deg);
            }
          }

          @keyframes centinelaMiddleRotation {
            from {
              transform: rotate(360deg);
            }

            to {
              transform: rotate(0deg);
            }
          }

          @keyframes centinelaCoreBreathing {
            0%, 100% {
              transform: scale(0.98);

              box-shadow:
                0 0 18px
                var(--centinela-glow),
                inset 0 0 18px
                rgba(255,255,255,0.05);
            }

            50% {
              transform: scale(1.035);

              box-shadow:
                0 0 35px
                var(--centinela-glow),
                inset 0 0 24px
                rgba(255,255,255,0.10);
            }
          }

          @keyframes centinelaBeamScan {
            0% {
              opacity: 0.16;
              transform:
                translateX(-50%)
                scaleX(0.55);
            }

            45% {
              opacity: 0.72;
              transform:
                translateX(-50%)
                scaleX(1);
            }

            100% {
              opacity: 0.16;
              transform:
                translateX(-50%)
                scaleX(0.55);
            }
          }

          @keyframes centinelaFloorPulse {
            0%, 100% {
              opacity: 0.28;
              transform:
                translateX(-50%)
                scale(0.90);
            }

            50% {
              opacity: 0.82;
              transform:
                translateX(-50%)
                scale(1.08);
            }
          }

          @keyframes centinelaCriticalPulse {
            0%, 100% {
              filter:
                brightness(0.92);
            }

            50% {
              filter:
                brightness(1.45);
            }
          }

          .centinela-core-stage {
            position: relative;

            width: 100%;
            max-width: 235px;
            height: 188px;

            margin: 0 auto;

            display: flex;
            align-items: center;
            justify-content: center;

            overflow: visible;

            animation:
              centinelaCoreEntrance
              900ms
              cubic-bezier(.2,.8,.2,1)
              both;
          }

          .centinela-core-beam {
            position: absolute;

            left: 50%;
            top: -20px;

            width: 84px;
            height: 95px;

            transform:
              translateX(-50%);

            transform-origin:
              center bottom;

            clip-path:
              polygon(
                44% 100%,
                56% 100%,
                100% 0,
                0 0
              );

            background:
              linear-gradient(
                to top,
                var(--centinela-accent),
                rgba(56,189,248,0.13),
                transparent
              );

            filter:
              blur(1px);

            pointer-events: none;

            animation:
              centinelaBeamScan
              2.4s
              ease-in-out
              infinite;

            z-index: 0;
          }

          .centinela-core-floor {
            position: absolute;

            left: 50%;
            bottom: 15px;

            width: 190px;
            height: 58px;

            transform:
              translateX(-50%);

            border-radius: 50%;

            border:
              1px solid
              var(--centinela-accent);

            box-shadow:
              0 0 18px
              var(--centinela-glow),
              inset 0 0 22px
              rgba(14,165,233,0.10);

            opacity: 0.7;

            animation:
              centinelaFloorPulse
              3s
              ease-in-out
              infinite;

            z-index: 0;
          }

          .centinela-core-floor::before,
          .centinela-core-floor::after {
            content: '';

            position: absolute;

            left: 50%;
            top: 50%;

            transform:
              translate(-50%, -50%);

            border-radius: 50%;

            border:
              1px solid
              var(--centinela-accent);

            opacity: 0.42;
          }

          .centinela-core-floor::before {
            width: 145px;
            height: 40px;
          }

          .centinela-core-floor::after {
            width: 103px;
            height: 26px;
          }

          .centinela-core-mechanism {
            position: relative;

            width: 146px;
            height: 146px;

            display: flex;
            align-items: center;
            justify-content: center;

            border-radius: 50%;

            transform-style:
              preserve-3d;

            z-index: 2;
          }

          .centinela-core-ring-outer {
            position: absolute;
            inset: 0;

            border-radius: 50%;

            background:
              conic-gradient(
                from 0deg,
                transparent 0deg 18deg,
                var(--centinela-accent) 18deg 42deg,
                transparent 42deg 82deg,
                rgba(226,232,240,0.88) 82deg 111deg,
                transparent 111deg 158deg,
                var(--centinela-accent) 158deg 189deg,
                transparent 189deg 231deg,
                rgba(148,163,184,0.72) 231deg 270deg,
                transparent 270deg 313deg,
                var(--centinela-accent) 313deg 342deg,
                transparent 342deg 360deg
              );

            -webkit-mask:
              radial-gradient(
                circle,
                transparent 60%,
                #000 61%
              );

            mask:
              radial-gradient(
                circle,
                transparent 60%,
                #000 61%
              );

            filter:
              drop-shadow(
                0 0 8px
                var(--centinela-glow)
              );

            animation:
              centinelaOuterRotation
              9s
              linear
              infinite;
          }

          .centinela-core-ring-middle {
            position: absolute;

            inset: 13px;

            border-radius: 50%;

            border:
              2px solid
              rgba(148,163,184,0.38);

            background:
              conic-gradient(
                from 45deg,
                transparent 0deg 40deg,
                var(--centinela-accent) 40deg 72deg,
                transparent 72deg 145deg,
                rgba(226,232,240,0.72) 145deg 180deg,
                transparent 180deg 252deg,
                var(--centinela-accent) 252deg 286deg,
                transparent 286deg 360deg
              );

            -webkit-mask:
              radial-gradient(
                circle,
                transparent 72%,
                #000 73%
              );

            mask:
              radial-gradient(
                circle,
                transparent 72%,
                #000 73%
              );

            animation:
              centinelaMiddleRotation
              6.5s
              linear
              infinite;
          }

          .centinela-core-ring-inner {
            position: absolute;

            inset: 30px;

            border-radius: 50%;

            border:
              1px solid
              var(--centinela-accent);

            background:
              radial-gradient(
                circle at 38% 30%,
                rgba(255,255,255,0.18),
                rgba(15,23,42,0.96) 55%
              );

            box-shadow:
              0 0 26px
              var(--centinela-glow),
              inset 0 0 22px
              rgba(255,255,255,0.06);

            animation:
              centinelaCoreBreathing
              2.8s
              ease-in-out
              infinite;
          }

          .centinela-core-shield {
            position: relative;

            width: 62px;
            height: 72px;

            display: flex;
            align-items: center;
            justify-content: center;

            filter:
              drop-shadow(
                0 0 10px
                var(--centinela-glow)
              );

            z-index: 4;
          }

          .centinela-core-stage-inactive
          .centinela-core-ring-outer,

          .centinela-core-stage-inactive
          .centinela-core-ring-middle,

          .centinela-core-stage-inactive
          .centinela-core-floor {
            animation-play-state:
              paused;
          }

          .centinela-core-stage-inactive
          .centinela-core-beam {
            display: none;
          }

          .centinela-core-stage-inactive
          .centinela-core-mechanism {
            opacity: 0.72;

            filter:
              grayscale(0.72)
              brightness(0.72);
          }

          .centinela-core-stage-alert {
            animation:
              centinelaCoreEntrance
              650ms
              cubic-bezier(.2,.8,.2,1)
              both,
              centinelaCriticalPulse
              1.15s
              ease-in-out
              infinite;
          }
/*
            ACABADO PREMIUM V2
          */

          @keyframes centinelaCoreFloat {
            0%, 100% {
              transform:
                perspective(700px)
                rotateX(8deg)
                translateY(2px);
            }

            50% {
              transform:
                perspective(700px)
                rotateX(5deg)
                translateY(-4px);
            }
          }

          @keyframes centinelaMetalShine {
            0% {
              transform:
                rotate(0deg);
            }

            100% {
              transform:
                rotate(360deg);
            }
          }

          @keyframes centinelaBeamSweep {
            0%, 100% {
              opacity: 0.20;

              transform:
                translateX(-50%)
                scaleX(0.42);
            }

            45% {
              opacity: 0.72;

              transform:
                translateX(-50%)
                scaleX(1);
            }

            65% {
              opacity: 0.48;

              transform:
                translateX(-50%)
                scaleX(0.72);
            }
          }

          .centinela-core-stage {
            max-width: 260px;
            height: 154px;

            margin:
              -2px auto 0;
          }

          /*
            El haz ahora sube mucho más.
          */
          .centinela-core-beam {
            top: -120px;

            width: 138px;
            height: 194px;

            clip-path:
              polygon(
                45% 100%,
                55% 100%,
                100% 0,
                0 0
              );

            background:
              linear-gradient(
                to top,
                var(--centinela-accent) 0%,
                rgba(56,189,248,0.34) 35%,
                rgba(56,189,248,0.11) 70%,
                transparent 100%
              );

            filter:
              blur(0.6px)
              drop-shadow(
                0 0 12px
                var(--centinela-glow)
              );

            mix-blend-mode:
              screen;

            animation:
              centinelaBeamSweep
              2.8s
              ease-in-out
              infinite;
          }

          /*
            Base elíptica inferior.
          */
          .centinela-core-floor {
            bottom: -3px;

            width: 190px;
            height: 52px;

            border:
              1px solid
              var(--centinela-accent);

            background:
              radial-gradient(
                ellipse,
                var(--centinela-glow) 0%,
                rgba(14,165,233,0.08) 42%,
                transparent 72%
              );

            box-shadow:
              0 0 24px
              var(--centinela-glow),
              inset 0 0 26px
              rgba(14,165,233,0.14);
          }

          /*
            Estructura tridimensional central.
          */
          .centinela-core-mechanism {
            width: 136px;
            height: 136px;

            isolation: isolate;

            animation:
              centinelaCoreFloat
              3.8s
              ease-in-out
              infinite;

            filter:
              drop-shadow(
                0 15px 16px
                rgba(0,0,0,0.42)
              );
          }

          /*
            Disco metálico que faltaba.
          */
          .centinela-core-mechanism::before {
            content: '';

            position: absolute;
            inset: 4px;

            border-radius: 50%;

            background:
              radial-gradient(
                circle at 42% 32%,
                rgba(255,255,255,0.30) 0%,
                rgba(148,163,184,0.10) 22%,
                rgba(15,23,42,0.96) 54%,
                #020817 78%
              ),
              conic-gradient(
                from 215deg,
                #253650,
                #d5deea,
                #263952,
                #07101f,
                #9cabbd,
                #1d2c43,
                #dce5ef,
                #253650
              );

            border:
              1px solid
              rgba(226,232,240,0.46);

            box-shadow:
              0 0 0 4px
              rgba(15,23,42,0.92),

              0 0 0 6px
              rgba(148,163,184,0.22),

              0 0 28px
              var(--centinela-glow),

              inset 0 2px 4px
              rgba(255,255,255,0.28),

              inset 0 -10px 18px
              rgba(0,0,0,0.58);

            z-index: 0;
          }

          /*
            Disco interno de cristal.
          */
          .centinela-core-mechanism::after {
            content: '';

            position: absolute;
            inset: 27px;

            border-radius: 50%;

            background:
              radial-gradient(
                circle at 42% 32%,
                rgba(255,255,255,0.13),
                rgba(8,25,48,0.96) 54%,
                rgba(2,8,23,1) 100%
              );

            border:
              1px solid
              var(--centinela-accent);

            box-shadow:
              0 0 18px
              var(--centinela-glow),

              inset 0 0 22px
              rgba(56,189,248,0.14);

            z-index: 3;
          }

          /*
            Anillo exterior más continuo
            y con acabado metálico.
          */
          .centinela-core-ring-outer {
            inset: -1px;

            background:
              conic-gradient(
                from 0deg,

                transparent 0deg 13deg,
                #d9e2ec 13deg 32deg,
                #53657c 32deg 43deg,

                transparent 43deg 71deg,
                var(--centinela-accent) 71deg 104deg,
                #b7c3d2 104deg 116deg,

                transparent 116deg 150deg,
                #3d5069 150deg 169deg,
                #e2e8f0 169deg 190deg,

                transparent 190deg 220deg,
                var(--centinela-accent) 220deg 254deg,
                #6f8298 254deg 266deg,

                transparent 266deg 304deg,
                #dce4ed 304deg 329deg,
                var(--centinela-accent) 329deg 348deg,

                transparent 348deg 360deg
              );

            -webkit-mask:
              radial-gradient(
                circle,
                transparent 56%,
                #000 57%,
                #000 70%,
                transparent 71%
              );

            mask:
              radial-gradient(
                circle,
                transparent 56%,
                #000 57%,
                #000 70%,
                transparent 71%
              );

            filter:
              drop-shadow(
                0 0 7px
                var(--centinela-glow)
              );

            z-index: 2;
          }

          /*
            Segundo anillo mecánico.
          */
          .centinela-core-ring-middle {
            inset: 15px;

            border: 0;

            background:
              conic-gradient(
                from 28deg,

                transparent 0deg 28deg,
                var(--centinela-accent) 28deg 62deg,

                transparent 62deg 115deg,
                #d7e0ea 115deg 143deg,

                transparent 143deg 198deg,
                var(--centinela-accent) 198deg 231deg,

                transparent 231deg 290deg,
                #71849b 290deg 318deg,

                transparent 318deg 360deg
              );

            -webkit-mask:
              radial-gradient(
                circle,
                transparent 65%,
                #000 66%,
                #000 79%,
                transparent 80%
              );

            mask:
              radial-gradient(
                circle,
                transparent 65%,
                #000 66%,
                #000 79%,
                transparent 80%
              );

            filter:
              drop-shadow(
                0 0 6px
                var(--centinela-glow)
              );

            z-index: 4;
          }

          /*
            Resplandor interior.
          */
          .centinela-core-ring-inner {
            inset: 32px;

            border:
              1px solid
              var(--centinela-accent);

            background:
              radial-gradient(
                circle at 40% 28%,
                rgba(255,255,255,0.18),
                rgba(15,23,42,0.82) 48%,
                rgba(2,8,23,0.98) 100%
              );

            box-shadow:
              0 0 24px
              var(--centinela-glow),

              inset 0 0 20px
              rgba(255,255,255,0.08);

            z-index: 5;
          }

          /*
            Escudo elevado sobre los anillos.
          */
          .centinela-core-shield {
            width: 66px;
            height: 76px;

            transform:
              translateZ(34px)
              scale(1.04);

            filter:
              drop-shadow(
                0 5px 5px
                rgba(0,0,0,0.50)
              )
              drop-shadow(
                0 0 12px
                var(--centinela-glow)
              );

            z-index: 8;
          }

          .centinela-core-stage-inactive
          .centinela-core-mechanism {
            animation: none;

            transform:
              perspective(700px)
              rotateX(8deg);

            opacity: 0.68;

            filter:
              grayscale(0.78)
              brightness(0.66)
              drop-shadow(
                0 10px 12px
                rgba(0,0,0,0.36)
              );
          }

          .centinela-core-stage-alert
          .centinela-core-mechanism {
            animation:
              centinelaCoreFloat
              2s
              ease-in-out
              infinite;
          }
          @media (
            prefers-reduced-motion:
            reduce
          ) {
            .centinela-core-stage,
            .centinela-core-ring-outer,
            .centinela-core-ring-middle,
            .centinela-core-ring-inner,
            .centinela-core-floor,
            .centinela-core-beam {
              animation:
                none !important;
            }
          }
        `}
      </style>

      {activo && (
        <div
          className="centinela-core-beam"
        />
      )}

      <div
        className="centinela-core-floor"
      />

      <div
        className="centinela-core-mechanism"
      >
        <div
          className="centinela-core-ring-outer"
        />

        <div
          className="centinela-core-ring-middle"
        />

        <div
          className="centinela-core-ring-inner"
        />

        <div
          className="centinela-core-shield"
        >
          <svg
            width="62"
            height="72"
            viewBox="0 0 62 72"
            fill="none"
            aria-hidden="true"
          >
            <path
              d="
                M31 3
                L54 12
                V31
                C54 48
                44 61
                31 68
                C18 61
                8 48
                8 31
                V12
                Z
              "
              fill="rgba(15,23,42,0.96)"
              stroke="var(--centinela-accent)"
              strokeWidth="3"
            />

            <path
              d="
                M31 10
                L47 16
                V31
                C47 43
                40 53
                31 59
                C22 53
                15 43
                15 31
                V16
                Z
              "
              fill="rgba(255,255,255,0.05)"
              stroke="rgba(255,255,255,0.55)"
              strokeWidth="1.5"
            />

            {activo ? (
              <>
                <path
                  d="
                    M24 31
                    V25
                    C24 16
                    38 16
                    38 25
                    V31
                  "
                  stroke="#ffffff"
                  strokeWidth="4"
                  strokeLinecap="round"
                />

                <rect
                  x="20"
                  y="29"
                  width="22"
                  height="19"
                  rx="5"
                  fill="var(--centinela-accent)"
                  stroke="#ffffff"
                  strokeWidth="1.5"
                />

                <circle
                  cx="31"
                  cy="38"
                  r="2.4"
                  fill="#ffffff"
                />

                <path
                  d="M31 40V44"
                  stroke="#ffffff"
                  strokeWidth="2"
                  strokeLinecap="round"
                />
              </>
            ) : (
              <>
                <path
                  d="
                    M25 31
                    V24
                    C25 17
                    34 15
                    38 20
                  "
                  stroke="#ffffff"
                  strokeWidth="4"
                  strokeLinecap="round"
                />

                <path
                  d="M38 20L42 17"
                  stroke="#ffffff"
                  strokeWidth="4"
                  strokeLinecap="round"
                />

                <rect
                  x="20"
                  y="29"
                  width="22"
                  height="19"
                  rx="5"
                  fill="#64748b"
                  stroke="#ffffff"
                  strokeWidth="1.5"
                />

                <circle
                  cx="31"
                  cy="38"
                  r="2.4"
                  fill="#ffffff"
                />

                <path
                  d="M31 40V44"
                  stroke="#ffffff"
                  strokeWidth="2"
                  strokeLinecap="round"
                />
              </>
            )}
          </svg>
        </div>
      </div>
    </div>
  );
}

function CentinelaPanel({
  onClose,
  vehiculoSeleccionado,
  setVehiculoSeleccionado
}) {
  const centinelaActivo = vehiculoSeleccionado?.centinelaActivo === true;
  const [activando, setActivando] = useState(false);
  const [isMobile, setIsMobile] = useState(isMobileLayout);
  const [accionEjecutando, setAccionEjecutando] = useState(null);

  const actualizarSalidaVisual = (salida) => {
    const cambios = {
      out1_on: { dout1Status: 'ON' },
      out1_off: { dout1Status: 'OFF' },
      out2_on: { dout2Status: 'ON' },
      out2_off: { dout2Status: 'OFF' },
      out3_on: { dout3Status: 'ON' },
      out3_off: { dout3Status: 'OFF' }
    };

    const cambio = cambios[salida];
    if (!cambio) return;

    setVehiculoSeleccionado((prev) => {
      if (!prev) return prev;

      return {
        ...prev,
        ...cambio
      };
    });
  };

  const enviarSalida = async (salida, accion) => {
    if (!vehiculoSeleccionado?.id) {
      alert('Selecciona primero un vehículo.');
      return;
    }

    if (salida === 'out1_on') {
      const confirmar = window.confirm(
        '¿Seguro que deseas activar el bloqueo del motor?'
      );

      if (!confirmar) return;
    }

    try {
      setAccionEjecutando(salida);

      const token = localStorage.getItem('token');

      const response = await fetch(
        `/api/devices/${vehiculoSeleccionado.id}/commands/output`,
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${token}`
          },
          body: JSON.stringify({
            output: salida
          })
        }
      );

      const data = await response.json();

     if (!data.success) {
  alert(
    data.message ||
    'El GPS no está disponible en este momento. Intenta nuevamente cuando recupere señal.'
  );
  return;
}
   if (data.outputState) {
  setVehiculoSeleccionado((prev) => {
    if (!prev) return prev;

    return {
      ...prev,
     dout1Status:
  data.outputState.dout1 === true
    ? 'ON'
    : data.outputState.dout1 === false
      ? 'OFF'
      : prev.dout1Status,

dout2Status:
  data.outputState.dout2 === true
    ? 'ON'
    : data.outputState.dout2 === false
      ? 'OFF'
      : prev.dout2Status,

dout3Status:
  data.outputState.dout3 === true
    ? 'ON'
    : data.outputState.dout3 === false
      ? 'OFF'
      : prev.dout3Status
    };
  });
}
      alert(`Comando enviado: ${accion}`);
  } catch (error) {
  alert(
    'No fue posible confirmar el comando. El GPS puede estar sin señal o sin conexión en este momento.'
  );
} finally {
      setAccionEjecutando(null);
    }
  };

  useEffect(() => {
    const checkMobile = () => {
      setIsMobile(isMobileLayout());
    };

    checkMobile();
    window.addEventListener('resize', checkMobile);

    return () => {
      window.removeEventListener('resize', checkMobile);
    };
  }, []);

 const ignicionActiva =
  vehiculoSeleccionado?.din1Status === 'ON' ||
  vehiculoSeleccionado?.din1 === true ||
  vehiculoSeleccionado?.din1 === 1 ||
  vehiculoSeleccionado?.ignitionRaw === true;

const puertasAbiertas =
  vehiculoSeleccionado?.din2Status === 'ON' ||
  vehiculoSeleccionado?.din2 === true ||
  vehiculoSeleccionado?.din2 === 1;

const movimientoActivo =
  vehiculoSeleccionado?.motion === 'EN MOVIMIENTO' ||
  vehiculoSeleccionado?.rawTeltonikaDirect?.status?.movement === true;

const jammerActivo =
  vehiculoSeleccionado?.rawTeltonikaDirect?.status?.jamming === true;

const estadoConexion =
  vehiculoSeleccionado?.connectionStatus || 'OFFLINE';

const gpsDisponible =
  estadoConexion === 'ONLINE' &&
  Number(vehiculoSeleccionado?.lat) !== 0 &&
  Number(vehiculoSeleccionado?.lng) !== 0;

/*
  Voltaje externo del vehículo.

  vehiculoSeleccionado.power:
  batería principal del vehículo.

  vehiculoSeleccionado.battery:
  batería interna de respaldo del GPS.
*/
const voltajeVehiculo = Number(
  vehiculoSeleccionado?.power
);

const lecturaVoltajeValida =
  Number.isFinite(voltajeVehiculo) &&
  voltajeVehiculo >= 0;

/*
  Consideramos desconexión de batería cuando
  el GPS reporta 1 voltio o menos.

  No se exige que el dispositivo esté ONLINE:
  el último reporte puede haber registrado
  la desconexión antes de quedar sin conexión.
*/
const energiaInterrumpida =
  lecturaVoltajeValida &&
  voltajeVehiculo <= 1;

const sensores = [
  {
    name: 'Batería',
    status:
      !lecturaVoltajeValida
        ? 'Sin lectura'
        : energiaInterrumpida
          ? 'Desconectada'
          : `${voltajeVehiculo.toFixed(2)} V`,
    color:
      energiaInterrumpida
        ? '#ef4444'
        : '#3b82f6'
  },
  {
    name: 'Ignición',
    status:
      ignicionActiva
        ? 'Encendida'
        : 'Apagada',
    color:
      ignicionActiva
        ? '#ef4444'
        : '#3b82f6'
  },
  {
    name: 'Movimiento',
    status:
      movimientoActivo
        ? 'En movimiento'
        : 'Sin movimiento',
    color:
      movimientoActivo
        ? '#ef4444'
        : '#3b82f6'
  },
  {
    name: 'Puertas',
    status:
      puertasAbiertas
        ? 'Abiertas'
        : 'Cerradas',
    color:
      puertasAbiertas
        ? '#ef4444'
        : '#3b82f6'
  },
  {
    name: 'Antijammer',
    status:
      jammerActivo
        ? 'Interferencia'
        : 'Estable',
    color:
      jammerActivo
        ? '#ef4444'
        : '#3b82f6'
  }
];

/*
  La activación se bloquea únicamente cuando
  Centinela está apagado y la ignición está encendida.

  Si Centinela ya está activo, se permite que la
  ignición genere la alerta correspondiente.
*/
const activacionCentinelaBloqueada =
  !centinelaActivo &&
  ignicionActiva;

let estadoVisual = {
  eyebrow: 'PROTECCIÓN DESACTIVADA',
  title: 'Centinela está en espera',
  description:
    'Activa la protección para vigilar cambios importantes en el vehículo.',
  color: '#64748b',
  background:
    'linear-gradient(145deg, #f8fafc, #e8eef5)'
};
if (activacionCentinelaBloqueada) {
  estadoVisual = {
    eyebrow: 'VEHÍCULO ENCENDIDO',
    title: 'Apaga el vehículo para activar Centinela',
    description:
      'Centinela solo puede activarse cuando la ignición está apagada.',
    color: '#f59e0b'
  };
}


if (centinelaActivo) {
  estadoVisual = {
    eyebrow: 'PROTECCIÓN ACTIVA',
    title: 'Vehículo protegido',
    description:
      'Centinela está supervisando el vehículo en tiempo real.',
    color: '#2563eb',
    background:
      'linear-gradient(145deg, #f5fbff, #ddecff)'
  };
}

if (centinelaActivo && ignicionActiva) {
  estadoVisual = {
    eyebrow: 'ACTIVIDAD DETECTADA',
    title: 'Ignición encendida',
    description:
      'El vehículo reporta el motor encendido.',
    color: '#f59e0b',
    background:
      'linear-gradient(145deg, #fffbeb, #fef3c7)'
  };
}

if (centinelaActivo && movimientoActivo) {
  estadoVisual = {
    eyebrow: 'VEHÍCULO EN MOVIMIENTO',
    title: 'Movimiento detectado',
    description:
      'Centinela detecta desplazamiento del vehículo.',
    color: '#0ea5e9',
    background:
      'linear-gradient(145deg, #f0f9ff, #dbeafe)'
  };
}

if (centinelaActivo && puertasAbiertas) {
  estadoVisual = {
    eyebrow: 'ATENCIÓN REQUERIDA',
    title: 'Puertas abiertas',
    description:
      'Se detectó apertura de puertas con Centinela activo.',
    color: '#ef4444',
    background:
      'linear-gradient(145deg, #fff7f7, #fee2e2)'
  };
}

if (centinelaActivo && energiaInterrumpida) {
  estadoVisual = {
    eyebrow: 'ALERTA DE ENERGÍA',
    title: 'Alimentación desconectada',
    description:
      'El dispositivo dejó de registrar voltaje externo.',
    color: '#ef4444',
    background:
      'linear-gradient(145deg, #fff7f7, #fee2e2)'
  };
}

if (centinelaActivo && jammerActivo) {
  estadoVisual = {
    eyebrow: 'ALERTA CRÍTICA',
    title: 'Interferencia detectada',
    description:
      'Centinela detectó una posible interferencia de señal.',
    color: '#dc2626',
    background:
      'linear-gradient(145deg, #fff1f2, #fecdd3)'
  };
}
  const acciones = [
    { name: 'Bloquear motor', salida: 'out1_on' },
    { name: 'Desbloquear motor', salida: 'out1_off' },
    { name: 'Activar claxon', salida: 'out2_on' },
    { name: 'Silenciar claxon', salida: 'out2_off' },
    { name: 'Abrir puertas', salida: 'out3_on' },
    { name: 'Cerrar puertas', salida: 'out3_off' }
  ];

  const toggleCentinela = async () => {
    if (activando) return;

    if (
  !centinelaActivo &&
  ignicionActiva
) {
  alert(
    'Apaga el vehículo para activar Centinela.'
  );

  return;
}

    if (!vehiculoSeleccionado?.id) {
      alert('Selecciona primero un vehículo.');
      return;
    }

    const nuevoEstado = !centinelaActivo;

    try {
      setActivando(true);

      const token = localStorage.getItem('token');

    const centinelaVehicleId =
  vehiculoSeleccionado.maccezVehicleId ||
  vehiculoSeleccionado.id;

const response = await fetch(
  `/api/devices/${centinelaVehicleId}/centinela`,
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${token}`
          },
          body: JSON.stringify({
            active: nuevoEstado
          })
        }
      );

      const data = await response.json();

      if (!data.success) {
        alert(data.message || 'No se pudo actualizar Centinela');
        return;
      }

      setVehiculoSeleccionado((prev) => {
        if (!prev) return prev;

        return {
          ...prev,
          centinelaActivo: data.active
        };
      });
    } catch (error) {
      alert('Error actualizando Modo Centinela');
    } finally {
      setActivando(false);
    }
  };

  const styles = {
overlay: {
  position: 'fixed',

  ...(isMobile
    ? {
        top:
          'calc(env(safe-area-inset-top, 0px) + 158px)',

        left: 0,
        right: 0,

        bottom:
          'calc(env(safe-area-inset-bottom, 0px) + 70px)',

        zIndex: 7000,

        padding:
          '10px 12px 8px',

        alignItems: 'stretch',

       background: `
  radial-gradient(
    circle at 50% 12%,
    rgba(14,165,233,0.18) 0%,
    rgba(30,64,175,0.08) 30%,
    rgba(2,8,23,0) 58%
  ),
  linear-gradient(
    180deg,
    #07172c 0%,
    #061326 46%,
    #030b18 100%
  )
`,
        backdropFilter: 'none',
        WebkitBackdropFilter: 'none',

        overflow: 'hidden'
      }
    : {
        inset: 0,

        zIndex: 99999,

        padding: 18,
        paddingTop: 70,

        alignItems: 'flex-start',

        background:
          'rgba(0,0,0,0.68)',

        backdropFilter:
          'blur(8px)',

        WebkitBackdropFilter:
          'blur(8px)'
      }),

  display: 'flex',
  justifyContent: 'center',

  boxSizing: 'border-box'
},

panel: {
  width:
    isMobile
      ? '100%'
      : 760,

  height:
    isMobile
      ? '100%'
      : 'auto',

  maxHeight:
    isMobile
      ? '100%'
      : 'none',

  borderRadius:
    isMobile
      ? 22
      : 20,

  background:
    '#05080d',

  border:
    '1px solid rgba(255,255,255,0.08)',

  boxShadow:
    isMobile
      ? '0 12px 32px rgba(15,23,42,0.18)'
      : '0 24px 60px rgba(0,0,0,0.55)',

  padding:
    isMobile
      ? 12
      : 20,

  color:
    '#ffffff',

  position:
    'relative',

  overflowX:
    'hidden',

  overflowY:
    isMobile
      ? 'hidden'
      : 'visible',

  boxSizing:
    'border-box',

  WebkitOverflowScrolling:
    'touch'
},
    close: {
      position: 'absolute',
      top: 14,
      right: 16,
      width: 30,
      height: 30,
      borderRadius: 8,
      border: '1px solid rgba(255,255,255,0.10)',
      background: '#0b0f16',
      color: '#ffffff',
      fontSize: 20,
      cursor: 'pointer',
      zIndex: 3
    },

hero: {
  width: '100%',
padding:
  isMobile
    ? '4px 2px 2px'
    : '10px 8px 6px',

  boxSizing: 'border-box'
},

heroHeader: {
  display: 'flex',
  alignItems: 'flex-start',
  justifyContent: 'space-between',

  gap: 12,
  paddingRight: 42,

marginBottom: isMobile ? 5 : 10
},

heroEyebrow: {
  marginBottom: 4,

  color: '#2563eb',

  fontSize: isMobile ? 9 : 10,
  lineHeight: 1,
  fontWeight: 950,

  letterSpacing: 1.5
},

heroVehicleName: {
  margin: 0,

  color: '#ffffff',

  fontSize: isMobile ? 21 : 30,
  lineHeight: 1,
  fontWeight: 950,

  letterSpacing: -0.8
},

visualCard: {
  position: 'relative',

  padding: isMobile
    ? '3px 10px 8px'
    : '12px 18px 20px',

  borderRadius: 22,

  background: `
    radial-gradient(
      circle at 50% 35%,
      rgba(30, 112, 214, 0.32) 0%,
      rgba(10, 48, 96, 0.18) 38%,
      rgba(2, 12, 29, 0) 68%
    ),
    linear-gradient(
      155deg,
      #071b36 0%,
      #041326 48%,
      #020b18 100%
    )
  `,

  border:
    '1px solid rgba(59,130,246,0.38)',

  boxShadow:
    '0 16px 36px rgba(2,8,23,0.34), inset 0 1px 0 rgba(255,255,255,0.08)',

  color: '#ffffff',

  overflow: 'visible'
},

visualState: {
  position: 'relative',
  zIndex: 2,

  textAlign: 'center',

marginTop: isMobile ? -2 : -4,
padding: isMobile ? '0 5px' : '0 8px' 
},

visualStateEyebrow: {
  color: estadoVisual.color,

  fontSize: 9,
  lineHeight: 1,
  fontWeight: 950,

  letterSpacing: 1.4,
  textTransform: 'uppercase'
},

visualStateTitle: {
  margin: isMobile ? '4px 0 0' : '7px 0 0',

  color: '#ffffff',

  fontSize: isMobile ? 18 : 23,
  lineHeight: 1.1,
  fontWeight: 950,

  letterSpacing: -0.45,

  textShadow:
    '0 2px 12px rgba(0,0,0,0.28)'
},

visualStateDescription: {
 margin: isMobile ? '4px auto 0' : '7px auto 0',

  maxWidth: 390,

  color: '#aebdd1',

  fontSize: isMobile ? 11 : 12,
  lineHeight: isMobile ? 1.25 : 1.4,
  fontWeight: 700
},

    iconWrap: {
      width: isMobile ? 50 : 58,
      height: isMobile ? 50 : 58,
      borderRadius: 14,
      background: '#0b0f16',
      border: '1px solid rgba(255,255,255,0.08)',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center'
    },

    icon: {
      width: isMobile ? 38 : 44,
      height: isMobile ? 38 : 44,
      objectFit: 'contain',
      filter: 'grayscale(100%) brightness(1.4)'
    },

    heroText: {
      textAlign: 'left'
    },

    title: {
      margin: 0,
      fontSize: isMobile ? 20 : 28,
      letterSpacing: 0.4,
      fontWeight: 800,
      color: '#ffffff'
    },

    heroBottom: {
      marginTop: 8,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      gap: isMobile ? 8 : 18
    },

    subtitle: {
      margin: 0,
      fontSize: isMobile ? 12 : 15,
      color: '#e5e7eb',
      fontWeight: 600
    },

    subtitleStrong: {
      margin: '3px 0 0',
      fontSize: isMobile ? 10 : 12,
      color: '#94a3b8',
      fontWeight: 500
    },

   content: {
  display: 'grid',

  gridTemplateColumns:
    isMobile
      ? '1fr'
      : '1.15fr 0.85fr',

  gap:
    isMobile
      ? 6
      : 14,

  marginTop:
    isMobile
      ? 6
      : 8
},

sensorsPanel: {
  borderRadius: 16,

  background:
    '#0b0f16',

  border:
    '1px solid rgba(255,255,255,0.08)',

  padding:
    isMobile
      ? 8
      : 14,

  boxSizing:
    'border-box'
},
    actionsPanel: {
      borderRadius: 16,
      background: '#0b0f16',
      border: '1px solid rgba(255,255,255,0.08)',
      padding: isMobile ? 10 : 14,
      boxSizing: 'border-box'
    },
cardHeader: {
  fontSize:
    isMobile
      ? 10
      : 12,

  fontWeight: 800,
  letterSpacing: 0.8,

  color:
    '#94a3b8',

  textTransform:
    'uppercase',

  marginBottom:
    isMobile
      ? 5
      : 10
},
sensorList: {
  display: 'grid',

  gap:
    isMobile
      ? 1
      : 4
},

  sensorItem: {
  minHeight:
    isMobile
      ? 27
      : 33,

  borderBottom:
    '1px solid rgba(255,255,255,0.06)',

  display: 'grid',

  gridTemplateColumns:
    isMobile
      ? '1fr 132px'
      : '1fr 130px',

  alignItems:
    'center',

  boxSizing:
    'border-box'
},
sensorName: {
  fontSize:
    isMobile
      ? 11
      : 13,

  fontWeight: 650,

  color:
    '#ffffff'
},

  sensorStatusWrap: {
  display: 'flex',

  alignItems:
    'center',

  justifyContent:
    'flex-end',

  gap: 7,

  width:
    '100%'
},
sensorDot: {
  width: 7,
  height: 7,

  minWidth: 7,

  borderRadius:
    '50%'
},

sensorStatus: {
  fontSize:
    isMobile
      ? 10.5
      : 12,

  fontWeight: 600,

  textAlign:
    'right',

  color:
    '#cbd5e1',

  whiteSpace:
    'nowrap'
},
    actionGrid: {
      display: 'grid',
      gridTemplateColumns: isMobile ? '1fr' : '1fr 1fr',
      gap: 8
    },

    actionButton: {
      minHeight: isMobile ? 34 : 42,
      borderRadius: 12,
      border: '1px solid rgba(255,255,255,0.08)',
      background: '#111827',
      color: '#ffffff',
      fontWeight: 600,
      cursor: 'pointer',
      display: 'grid',
      gridTemplateColumns: '1fr 18px',
      alignItems: 'center',
      textAlign: 'left',
      padding: isMobile ? '0 10px' : '0 12px',
      fontSize: isMobile ? 12 : 13
    },

    actionSmall: {
      color: '#3b82f6',
      fontSize: 20,
      textAlign: 'right',
      fontWeight: 300,
      lineHeight: 1
    },

mainButton: {
  width: '100%',

  minHeight:
    isMobile
      ? 36
      : 44,

  marginTop:
    isMobile
      ? 7
      : 12,

  padding:
    '0 14px',

  borderRadius: 14,

  border:
    '1px solid rgba(37,99,235,0.25)',

  background:
    'linear-gradient(135deg, #0ea5e9, #2563eb)',

  color: '#ffffff',

  boxShadow:
    '0 8px 20px rgba(37,99,235,0.22)',

  fontSize:
    isMobile
      ? 11
      : 13,

  fontWeight: 950,
  letterSpacing: 0.5,

  cursor: 'pointer',

  opacity:
    activando
      ? 0.6
      : 1
},

mainButtonOff: {
  border:
    '1px solid rgba(148,163,184,0.22)',

  background:
    'linear-gradient(135deg, #475569, #1e293b)',

  boxShadow:
    '0 8px 20px rgba(15,23,42,0.18)'
},

mainButtonBlocked: {

  border:

    '1px solid rgba(245,158,11,0.38)',

  background:

    'linear-gradient(135deg, #78350f, #92400e)',

  color:

    '#fde68a',

  boxShadow:

    '0 8px 20px rgba(245,158,11,0.16)',

  cursor:

    'not-allowed'

}
  };

  applyCentinelaLightTheme(styles, {
    active: centinelaActivo, state: estadoVisual, mobile: isMobile
  });

  return (
    <>
      {isMobile && <div className="centinela-light-backdrop" aria-hidden="true" />}
      <div style={styles.overlay} className="centinela-light">
      <div style={styles.panel}>
        <button style={styles.close} onClick={onClose}>
          ×
        </button>

   <div style={styles.hero}>
  <div style={styles.heroHeader}>
    <div>
      <div style={styles.heroEyebrow}>
        SEGURIDAD INTELIGENTE
      </div>

      <h1 style={styles.heroVehicleName}>
        {vehiculoSeleccionado?.name || 'Centinela'}
      </h1>
    </div>
  </div>

  <div style={styles.visualCard}>
    <CentinelaVehicleVisual
      activo={centinelaActivo}
      puertasAbiertas={puertasAbiertas}
      movimientoActivo={movimientoActivo}
      energiaInterrumpida={energiaInterrumpida}
      ignicionActiva={ignicionActiva}
      jammerActivo={jammerActivo}
      color={estadoVisual.color}
    />

    <div style={styles.visualState}>
      <div style={styles.visualStateEyebrow}>
        {estadoVisual.eyebrow}
      </div>

      <h2 style={styles.visualStateTitle}>
        {estadoVisual.title}
      </h2>

      <p style={styles.visualStateDescription}>
        {estadoVisual.description}
      </p>
    </div>

   <button
  type="button"
  style={{
    ...styles.mainButton,

    ...(centinelaActivo
      ? styles.mainButtonOff
      : {}),

    ...(activacionCentinelaBloqueada
      ? styles.mainButtonBlocked
      : {})
  }}
  onClick={toggleCentinela}
  disabled={
    activando ||
    activacionCentinelaBloqueada
  }
>
  {activando
    ? 'PROCESANDO...'
    : centinelaActivo
      ? 'DESACTIVAR CENTINELA'
      : activacionCentinelaBloqueada
        ? 'APAGA EL VEHÍCULO PARA ACTIVAR'
        : 'ACTIVAR CENTINELA'}
</button>
  </div>
</div>
        <div style={styles.content}>
          <div style={styles.sensorsPanel}>
            <div style={styles.cardHeader}>Sensores protegidos</div>

            <div style={styles.sensorList}>
              {sensores.map((sensor) => (
                <div key={sensor.name} style={styles.sensorItem}>
                  <span style={styles.sensorName}>{sensor.name}</span>

                  <span style={styles.sensorStatusWrap}>
                    <span
                      style={{
                        ...styles.sensorDot,
                        background: sensor.color
                      }}
                    />
                    <span style={styles.sensorStatus}>
                      {sensor.status}
                    </span>
                  </span>
                </div>
              ))}
            </div>
          </div>


        </div>
      </div>
    </div>
    </>
  );
}

export default CentinelaPanel;